<template>
  <div class="m-case-space" :data-comp="blok.component"></div>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
});
</script>

<style lang="scss" scoped>
.m-case-space {
  --span: v-bind(props.blok.span);

  flex: 0 1 calc(var(--span) / 12 * 100%);
  display: flex;
  justify-content: center;
  align-items: center;

  .--editor & {
    border-top: 1px dashed #dab2ff;
  }
}
</style>
